import type { BentonCountyData } from '../types';
import { formatTableData, getData } from '../utils/formatters';

const BENTON_COUNTY_ROWS = [
  {
    label: 'Address',
    getValue: (data: BentonCountyData) => getData(data, 'address', 'No address available')
  },
  {
    label: 'Unit',
    getValue: (data: BentonCountyData) => getData(data, 'unit', 'No unit available')
  },
  {
    label: 'City, Zip',
    getValue: (data: BentonCountyData) => `${getData(data, 'city', 'N/A')}, ${getData(data, 'zip', 'N/A')}`
  },
  {
    label: 'Lot Number',
    getValue: (data: BentonCountyData) => getData(data, 'lot', 'No lot number available')
  },
  {
    label: 'Subdivision',
    getValue: (data: BentonCountyData) => getData(data, 'subdivisionName', 'No subdivision information available')
  },
  {
    label: 'Acres',
    getValue: (data: BentonCountyData) => getData(data, 'acres', 'No acres information available')
  },
  {
    label: 'EMS / Fire District',
    getValue: (data: BentonCountyData) =>
      `${getData(data, 'emsDistrict', 'No EMS district available')} / ${getData(
        data,
        'fireDistrict',
        'No fire district available'
      )}`
  },
  {
    label: 'Justice of the Peace',
    getValue: (data: BentonCountyData) =>
      `${getData(data, 'jpRep', 'No JP name available')}, ${getData(data, 'jpPhone', 'No JP phone available')}, ${getData(
        data,
        'jpEmail',
        'No JP email available'
      )}`
  },
  {
    label: 'Owner Name',
    getValue: (data: BentonCountyData) => getData(data, 'ownerName', 'No owner name available')
  },
  {
    label: 'Deed Type',
    getValue: (data: BentonCountyData) => getData(data, 'currentDeedType', 'No deed type available')
  },
  {
    label: 'School District',
    getValue: (data: BentonCountyData) => getData(data, 'schoolDistrict', 'No school district available')
  },
  {
    label: 'Arkansas House District',
    getValue: (data: BentonCountyData) => getData(data, 'houseRep', 'No house representative available')
  },
  {
    label: 'Arkansas Senate District',
    getValue: (data: BentonCountyData) => getData(data, 'senateRep', 'No senate representative available')
  },
  {
    label: 'Parcel ID',
    getValue: (data: BentonCountyData) => getData(data, 'parcelId', 'No parcel ID available')
  }
];

export const formatBentonCountyData = (data: BentonCountyData): string => {
  return formatTableData(data, BENTON_COUNTY_ROWS);
}; 